import React, { useContext } from 'react';
import cn from 'classnames';
import _get from 'lodash/get';
import _size from 'lodash/size';
import styles from './index.module.scss';

import { If, isSSRTheme } from 'utils';
import { EcommPlatform, UiKit } from 'components';
import { AuthContext } from 'context/AuthContext';

export default function StoreSelect({ onChange = () => {} }) {
  const { storeProperties, permittedStores } = useContext(AuthContext);

  const storeName = _get(storeProperties, 'store_unique_name', '');
  const hasMultipleStoreAccess = _size(permittedStores) > 1;

  const { storesList, storePlatformIcon } = permittedStores.reduce(
    (acc, { name, rr_store_id, seller_store_guid, ecommerce_platform }) => {
      const storeId = isSSRTheme() ? seller_store_guid : rr_store_id;
      const isSelected = name === storeName;
      if (isSelected) {
        acc.storePlatformIcon = ecommerce_platform;
      } else {
        acc.storesList.push(
          <UiKit.Dropdown.Option
            key={storeId}
            isActive={isSelected}
            onClick={() => !isSelected && onChange({ id: storeId, name })}
          >
            <div className={styles.option}>
              <EcommPlatform.Icon
                source={ecommerce_platform}
                className={styles.icon}
              />
              {name}
            </div>
          </UiKit.Dropdown.Option>
        );
      }
      return acc;
    },
    { storesList: [], storePlatformIcon: null }
  );

  return (
    <UiKit.Dropdown className={styles.container}>
      <UiKit.Dropdown.Trigger
        caret={hasMultipleStoreAccess}
        className={cn(styles.trigger, {
          [styles.empty]: !hasMultipleStoreAccess
        })}
      >
        <EcommPlatform.Icon
          source={storePlatformIcon}
          className={styles.icon}
        />
        {storeName}
      </UiKit.Dropdown.Trigger>
      <If test={hasMultipleStoreAccess}>
        <UiKit.Dropdown.Menu>
          <UiKit.Dropdown.Option disabled>
            Switch to another store
          </UiKit.Dropdown.Option>
          {storesList}
        </UiKit.Dropdown.Menu>
      </If>
    </UiKit.Dropdown>
  );
}
